import { Controller } from "@hotwired/stimulus"
import { FetchRequest } from '@rails/request.js'

export default class extends Controller {
  static targets = ["table"]

  datatableInstance = null

  connect() {
    this.initializeOrRefreshDataTable()
  }

  disconnect() {
    this.cleanup()
    document.removeEventListener("turbo:before-cache", this.cleanup.bind(this))
  }

  initializeOrRefreshDataTable() {
    if (this.hasTableTarget) {
      if (this.datatableInstance) {
        this.cleanup()
      }
      this.initDataTable()
    }
  }

  initDataTable() {
    // Rows are rendered server-side (notifications/_notification_row): [sort_date, html].
    this.datatableInstance = $(this.tableTarget).DataTable({
      processing: true,
      serverSide: true,
      filter: true,
      orderMulti: false,
      ajax: {
        url: this.data.get("source"),
        type: "GET"
      },
      columns: [
        { data: "0", visible: false },
        { data: "1" }
      ],
      order: [[0, 'desc']],
      dom: '<"row"<"col-md-6"><"col-md-6">>rt<"row"<"col-md-12"ip>>',
      displayLength: 50,
      lengthMenu: [10, 25, 50, 75, 100],
      responsive: true,
      createdRow: (row, data) => {
        $(row).html(data[1])
      },
      ...window.datatablesDefaults
    })
  }

  cleanup() {
    if (this.datatableInstance) {
      this.datatableInstance.destroy(true)
      this.datatableInstance = null
    }
  }

  navigateAndMarkRead(event) {
    const link = event.currentTarget
    const isRead = link.dataset.read === "true"

    if (!isRead) {
      const id = link.dataset.id
      const request = new FetchRequest('patch', `/notifications/${id}/read`, { responseKind: 'turbo-stream' })
      request.perform()
    }
  }

  async toggleRead(event) {
    event.preventDefault()
    event.stopPropagation()

    const target = event.currentTarget
    const id = target.dataset.id
    const isRead = target.dataset.read === "true"

    const url = `/notifications/${id}/read`
    const method = isRead ? 'delete' : 'patch'

    const request = new FetchRequest(method, url, { responseKind: 'turbo-stream' })
    const response = await request.perform()

    if (response.ok) {
      const newRead = !isRead
      const row = target.closest('tr')
      const card = row.querySelector('td.o-list-card')

      // Update all toggleRead targets in this row (header div)
      const headerToggle = card.querySelector('.notification-header-toggle')
      if (headerToggle) {
        headerToggle.dataset.read = newRead
        const toggleIcon = headerToggle.querySelector('.o-toggle-icon')
        if (toggleIcon) {
          toggleIcon.classList.toggle('is-checked', newRead)
        }
      }

      card.classList.toggle('o-list-card--unread', !newRead)

      const link = card.querySelector('[data-action*="navigateAndMarkRead"]')
      if (link) {
        link.dataset.read = newRead
      }
    }
  }
}
